module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper-content"
  }, [(_vm.isHtml) ? _c('div', {
    staticClass: "content-description",
    domProps: {
      "innerHTML": _vm._s(_vm.content.description)
    }
  }) : _c('div', {
    staticClass: "content-description"
  }, [_vm._v(_vm._s(_vm.content.description))]), _vm._v(" "), (_vm.content.urlImages) ? _c('div', _vm._l((_vm.content.urlImage), function(item, index) {
    return _c('div', {
      key: index
    }, [_c('img', {
      staticClass: "content-img",
      attrs: {
        "src": item,
        "alt": item
      }
    })])
  })) : (_vm.content.urlImage) ? _c('div', [_c('img', {
    staticClass: "content-img",
    attrs: {
      "src": _vm.content.urlImage,
      "alt": _vm.content.urlImage
    }
  })]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-365f82cc","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/detail/content.vue
// module id = 1092
// module chunks = 1